import React, { Component } from "react"
import PropTypes from "prop-types"
import ReactDOM from "react-dom"

import "./AccountMenu.scss"

class AccountMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      accountMenuState: "closed",
    }
  }

  accountMenuAnimateIn = () => {
    this.setState({
      accountMenuState: "animate-in",
    })
    setTimeout(() => {
      this.setState({
        accountMenuState: "open",
      })
    }, 100)
  }

  toggleAccountMenu = () => {
    if (!this.props.isMenuOpen) {
      this.setState({
        accountMenuState: "closed",
      })
      return
    }
    this.accountMenuAnimateIn()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isMenuOpen !== prevProps.isMenuOpen) {
      this.toggleAccountMenu()
    }

    if (
      this.props.isMenuOpen &&
      prevProps.children.props.location.pathname !==
        this.props.children.props.location.pathname
    ) {
      this.props.close()
    }
  }

  render() {
    let { accountMenuState } = this.state

    return (
      <div className={`accountMenu ${accountMenuState}`}>
        {this.props.children}
      </div>
    )
  }
}

AccountMenu.propTypes = {
  isMenuOpen: PropTypes.bool.isRequired,
  close: PropTypes.func,
}

export default AccountMenu
